<h1>Caller Campaigns</h1>
<div class="live-preview">
	<div class="row">
		<div class="col-xl-12">
			<div class="table-responsive table-card mt-3 mb-1">
				<table class="table">
					<thead class="bg-light">
						<tr class="bg-light text-muted">
							<th class="sort" data-sort="id" sortable="id">
								ID
							</th>
							<th
								class="sort"
								data-sort="name"
								sortable="name"
								scope="col"
								style="width: 15%"
							>
								Name
							</th>
							<th
								class="sort"
								data-sort="zone"
								sortable="zone"
								scope="col"
							>
								Timezone
							</th>
							<th
								class="sort"
								data-sort="records"
								sortable="records"
								scope="col"
							>
								Prospects
							</th>
							<th
								class="sort"
								data-sort="leads_needed"
								sortable="leads_needed"
								scope="col"
							>
								Needed
							</th>
							<th
								class="sort"
								data-sort="industry"
								sortable="industry"
								scope="col"
							>
								Industry
							</th>
							<th scope="col">Types</th>
							<th scope="col">Callbacks</th>
							<th scope="col">Actions</th>
						</tr>
					</thead>
					<tbody>
						<tr
							*ngFor="
								let data_campaign of ListJsListCampaigns$
									| async
							"
						>
							<td>
								<span class="text-muted" style="width: 20%">{{
									data_campaign.name
								}}</span>
							</td>
							<td>{{ data_campaign.zone }}</td>
							<td>{{ data_campaign.records }}</td>
							<td>{{ data_campaign.leads_needed }}</td>
							<td>{{ data_campaign.industry }}</td>
							<td [innerHTML]="data_campaign.types"></td>
							<td>0</td>
							<td>
								<button
									type="button"
									class="btn btn-primary btn-icon waves-effect waves-light"
									style="margin: 0 5px"
									ngbTooltip="Calendar"
									placement="top"
								>
									<i class="ri-calendar-line"></i>
								</button>
								<button
									type="button"
									class="btn btn-warning btn-icon waves-effect waves-light"
									style="margin: 0 5px"
									ngbTooltip="Callback"
									placement="top"
								>
									<i class="ri-fire-fill"></i>
								</button>
								<button
									type="button"
									class="btn btn-danger btn-icon waves-effect waves-light"
									style="margin: 0 5px"
									ngbTooltip="Start Calling"
									placement="top"
								>
									<i class="ri-phone-fill"></i>
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div
				class="row justify-content-md-between align-items-md-center gy-2"
			>
				<div class="col col-sm-6">
					<!-- <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
							Showing
							{{service.startIndex}} to
							{{service.endIndex}} of {{service.totalRecords}}
							entries
					</div> -->
				</div>
				<div class="col col-sm-6">
					<div
						class="text-sm-right float-sm-end listjs-pagination"
					></div>
				</div>
			</div>
		</div>

		<!--end col-->
	</div>
	<!--end row-->
</div>
